export const HASH_SHA_256 = Symbol('sha256');
export const HASH_SHA_512 = Symbol('sha512');
